<template>
  <section class="c-section c-section--blog">
    <div class="c-section-banner">
      <div class="container align-items-center justify-content-justify">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <h1 data-aos="fade-right" class="c-section-banner__title">
              {{ context.banner.titulo }}
            </h1>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <figure class="c-section-banner__figure position-relative">
              <div class="c-section-banner__figure-shadow h-100">
                <img class="h-100" src="@/assets/images/banner-profile-shadow.png">
              </div>
                <img class="h-100 position-relative" src="@/assets/images/banner-profile.png">
            </figure>
          </div>
        </div>
      </div>
    </div>
    <div class="c-blog-list">
      <div class="container">
        <div class="row gx-4 gy-4">
          <div
            v-for="(article, iarticle) of context.articles"
            :key="`article-${iarticle}`"
            class="col-12 col-md-6 col-lg-4"
            data-aos="fade-up"
            :data-aos-delay="100 * (iarticle + 1)"
          >
            <div class="c-card">
              <figure class="c-card__figure">
                <img class="w-100" :src="article.thumbnail ? article.thumbnail.src : ''">
              </figure>
              <div class="c-card__content">
                <div>
                  <span class="c-card__date">
                    <Icon icon="material-symbols:calendar-month-outline-rounded" />
                    <span>{{article.date}}</span>
                  </span>
                  <h3 class="c-card__title">
                    {{ article.post_title }}
                  </h3>
                </div>
                <router-link
                  :to="`/blog/${article.slug}`"
                  class="c-card__link"
                >
                  Read more
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      context: {},
      contextLoading: true,
    };
  },
  mounted() {
    const headerEl = document.getElementsByClassName('c-header')[0];
    headerEl.classList.add('active');
  },
  computed: {
    ...mapState(['general']),
  },
  created() {
    this.getFullContext({ type: 'page', slug: 'blog' });
  },
  methods: {
    getArticles() {
      const request = `${process.env.VUE_APP_API}/pages/articles/data`;

      this.articles.isLoading = true;

      fetch(request)
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          throw res;
        })
        .then((response) => {
          if (response.status) {
            this.articles.data = response.data.articles;
            this.articles.paginationTotal = response.data.pagination.total;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.articles.isLoading = false;
        });
    },
  },
};
</script>
